import React from 'react';
import { string, shape } from 'prop-types';
import DefaultContainer from '../DefaultContainer';
import Image from '../Image';
import styles from './style.module.scss';

const SingleImageSection = ({ image, backgroundColor }) => (
  <DefaultContainer noPadding style={{ backgroundColor }}>
    <Image
      source={image}
      alt="we app office"
      className={styles.image}
    />
  </DefaultContainer>
);

SingleImageSection.propTypes = {
  image: shape({
    main: string,
    fall: string,
  }).isRequired,
  backgroundColor: string,
};

SingleImageSection.defaultProps = {
  backgroundColor: null,
};

export default SingleImageSection;
